import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { ethCallRaw, isEvmAddress } from "./erc4626Rpc";

/** keccak256("asset()")[:4] — ERC-4626 standard function selector */
const ERC4626_ASSET_SELECTOR = "0x38d52e0f";
async function fetchVaultAsset(vaultAddress: string, chainId: number): Promise<string> {
  const raw = await ethCallRaw(vaultAddress, ERC4626_ASSET_SELECTOR, chainId);
  return ("0x" + raw.slice(26)).toLowerCase();
}

/**
 * Hook that resolves the underlying token address of an ERC-4626 vault.
 * Returns the token address string (lowercase, checksumless) or undefined.
 */
export function useErc4626Asset(vaultAddress, chainId, t0) {
  const $ = _c(12);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] !== chainId || $[1] !== vaultAddress) {
    t1 = ["erc4626-asset", vaultAddress, chainId];
    t2 = () => fetchVaultAsset(vaultAddress, chainId);
    $[0] = chainId;
    $[1] = vaultAddress;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== chainId || $[5] !== enabled || $[6] !== vaultAddress) {
    t3 = enabled && !!vaultAddress && !!chainId && isEvmAddress(vaultAddress);
    $[4] = chainId;
    $[5] = enabled;
    $[6] = vaultAddress;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: Infinity,
      gcTime: 3600000,
      retry: 1
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return useQuery(t4);
}